// extracted by mini-css-extract-plugin
export default {"about":"About_about__tFYRZ","AbountContainer":"About_AbountContainer__YpYOw","imageContainer":"About_imageContainer__EY1Kf"};